// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1iZad","productName":"Table_productName__2GyxO"};